// import { useEffect, useRef } from "react";
import styles from "./styles.module.scss";

import LostHorror from "assets/images/keyLost/lostHorror.png";
import LostHorror1440 from "assets/images/keyLost/lostHorror1440.png";
import Redman from "assets/images/keyLost/redman.png";

import Yellow from "assets/images/keyLost/yellow.png";
import Yellow1440 from "assets/images/keyLost/yellow1440.png";
import Yellow768 from "assets/images/keyLost/yellow768.png";
import YellowLeft from "assets/images/keyLost/yellowLeft.png";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import { RouterPathEnum } from "shared/enums/commonEnums";
import { NotScrollJournalPage } from "components/frontComponents/notScrollJournalPage/NotScrollJournalPage";

export const KeyLost = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.keylost}>
      <NotScrollJournalPage
        leftContent={
          <div className={styles.containerLeft}>
            <picture>
              <source media="(min-width: 1620px)" srcSet={LostHorror} />

              <img
                src={LostHorror1440}
                className={styles.picture}
                alt="keylost"
                loading="lazy"
              />
            </picture>

            <img src={YellowLeft} className={styles.yellowLeft} alt="" />
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            <div className={styles.pictureholder}>
              <img
                src={Redman}
                alt="kyberfitKeyLost"
                className={styles.picture}
              />
            </div>
            <div className={styles.buttonsholder}>
              <div className={styles.emailholder}>
                <form className={styles.formKeyLost}>
                  <div className={styles.labeledInput}>
                    <p className={styles.inputitle}>Укажите эфирную почту</p>
                    <label className={styles.label}>
                      <p className={styles.inputlegend}>Эфирная почта</p>

                      <div className={styles.inputfake}>
                        <input
                          className={styles.inputcontrol}
                          type="email"
                          name="email"
                          // value={email}
                          // onChange={onChangePassword}
                          placeholder="Укажите почту"
                        />
                      </div>
                    </label>
                  </div>
                </form>
                <Button
                  viewVariant="secondary"
                  text="отправить инструкции"
                  className={styles.button}
                  onClick={() => navigate(RouterPathEnum.Auth)}
                />
              </div>
              <div className={styles.backbuttonholder}>
                <Button
                  viewVariant="secondary"
                  text="вернуться"
                  className={styles.buttonback}
                  onClick={() => navigate(RouterPathEnum.FirstPage)}
                />
              </div>
            </div>

            <div className={styles.yellow}>
              <img
                src={Yellow768}
                alt="saveYouBubble"
                className={styles.yellowpicture}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};
